import { render, staticRenderFns } from "./DaftarUserUpdateComponent.vue?vue&type=template&id=904dfc5e"
import script from "./DaftarUserUpdateComponent.vue?vue&type=script&lang=js"
export * from "./DaftarUserUpdateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports